<template>
  <div>
    <v-icon v-if="channel.name === 'CALL'" color="#5caded" size="18" class="mr-1">mdi-phone</v-icon>
    <v-icon v-else-if="channel.name === 'EMAIL'" color="#9ccc65" size="18" class="mr-1"
      >mdi-email</v-icon
    >
    <v-icon v-else-if="channel.name === 'SMS'" color="#ffc107" size="18" class="mr-1"
      >mdi-message-processing</v-icon
    >
    <v-icon v-else-if="channel.name === 'FBM'" color="#373ee0" size="18" class="mr-1"
      >mdi-facebook-messenger</v-icon
    >
    {{ channel.text }}
  </div>
</template>

<script>
export default {
  name: 'DaktelaActivityChannel',
  props: {
    channel: {
      type: Object,
      required: true,
    },
    max: {
      type: Boolean,
      default: true,
    },
  },
}
</script>
